import * as React from 'react';
export const IcCooling = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.29 15.63l-1.37-.79.4-.11a1.001 1.001 0 00-.123-1.969 1 1 0 00-.397.039l-2.33.63L14 12l2.47-1.43 2.33.63h.26a1.008 1.008 0 10.26-2l-.4-.11 1.37-.79a1.004 1.004 0 00-1-1.74l-1.37.8L18 7a1 1 0 10-1.93-.52l-.63 2.33L13 10.27V7.41l1.71-1.7a1.004 1.004 0 10-1.42-1.42l-.29.3V3a1 1 0 00-2 0v1.59l-.29-.3a1.003 1.003 0 10-1.42 1.42L11 7.41v2.86L8.53 8.84 7.9 6.51a1 1 0 00-1.22-.71A1 1 0 006 7l.11.4-1.37-.8a1.003 1.003 0 00-1 1.74l1.37.79-.4.11a1.008 1.008 0 00.26 2h.26l2.33-.63L10 12l-2.47 1.43-2.33-.63a1 1 0 10-.52 1.93l.4.11-1.37.79a1.003 1.003 0 101 1.74l1.37-.8L6 17a1 1 0 00.71 1.23c.086.01.174.01.26 0a1 1 0 001-.74l.63-2.33 2.4-1.43v2.86l-1.71 1.7a1 1 0 00.325 1.639 1 1 0 001.095-.219l.29-.3V21a1 1 0 102 0v-1.59l.29.3a1.002 1.002 0 001.639-.325 1.002 1.002 0 00-.219-1.095L13 16.59v-2.86l2.47 1.43.63 2.33a1 1 0 001 .74c.086.01.174.01.26 0A1 1 0 0018 17l-.11-.4 1.37.8a1 1 0 00.5.13 1 1 0 00.5-1.87l.03-.03z'
      fill='currentColor'
    />
  </svg>
);
